(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kimmies-home"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.kl-card[href^="#kl-chapter-"], .kl-pillar[href^="#kl-chapter-"]');
    if (!link) return;
    const detail = document.getElementById(link.getAttribute('href').slice(1));
    if (detail) detail.open = true;
  });
  function openKimmiesChapter() {
    if (!window.location.hash.startsWith('#kl-chapter-')) return;
    const detail = document.getElementById(window.location.hash.slice(1));
    if (detail) detail.open = true;
  }
  openKimmiesChapter();
  window.addEventListener('hashchange', openKimmiesChapter);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
